




















































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";

import PaymentExportInfoJson from "../../shared/PaymentExportInfoJson";
import { PaymentExportType, PaymentExportTypeNames } from "../../shared/PaymentExportType";

import { UserPermissionRank } from "../../shared/UserPermissionRank";

export default Vue.extend({
  name: "PaymentsExported",
  components: {
    Loading,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
    BirthdayBookingStatusNames: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      showDetails: false,
      UserPermissionRank: UserPermissionRank,
      exportedPayments: null as PaymentExportInfoJson[] | null,
      isExporting: false,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    loadData() {
      this.loadExportedPayments();
    },

    async loadExportedPayments() {
      this.exportedPayments = null;
      if (this.restClient != null) {
        try {
          this.exportedPayments = await this.restClient.getRecentPaymentExports();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async downloadExportedPayments(downloadInfo: PaymentExportInfoJson) {
      this.isExporting = true;

      try {
        var data = await this.restClient.downloadPaymentExportFile(downloadInfo);
        if (data != null) {
          let atag = document.createElement("a");
          atag.style.display = "none";
          document.body.appendChild(atag);

          let blob = new Blob([data], { type: "octet/stream" });
          let url = window.URL.createObjectURL(blob);

          atag.href = url;
          atag.download = "payment_" + DateFormatter.formatFilenameDateTime(new Date(downloadInfo.dateTime)) + ".zip";
          atag.click();
          window.URL.revokeObjectURL(url);

          this.isExporting = false;
          this.loadData();
        }
      } catch (e) {
        this.isExporting = false;
        alert(e.message);
      }
    },

    getExportedPaymentsTypeName(type: PaymentExportType) {
      let typeName = PaymentExportTypeNames[type];

      if (typeName === undefined) {
        typeName = "Unbekannt";
      }

      return typeName;
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {},
});
